var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.5,
    height: 48,
    viewBox: "0 0 44.5 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_84",
    x: 0,
    y: 0,
    width: 44.5,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_85",
    x: 23.896,
    y: 5.385,
    width: 15.22,
    height: 18.721,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_58",
    "data-name": "Groupe 58",
    transform: "translate(-647.461 -44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 647.46, 44)",
    filter: "url(#Trac\\xE9_84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84-2",
    "data-name": "Trac\\xE9 84",
    d: "M687.461,56.2c-.129.713-.208,1.44-.395,2.138A11.4,11.4,0,0,1,672.848,66.4a.522.522,0,0,0-.6.149c-.725.745-1.478,1.463-2.209,2.2a1.315,1.315,0,0,1-1.021.418c-.563-.014-1.127,0-1.731,0,0,.6,0,1.175,0,1.748a1.079,1.079,0,0,1-1.371,1.2c-.444-.06-.89-.1-1.367-.154-.058.608-.126,1.19-.168,1.775-.073.991-.373,1.3-1.356,1.389-.585.051-1.17.106-1.8.164.05.448.08.882.15,1.308a1.327,1.327,0,0,1-.421,1.283c-.422.393-.823.81-1.227,1.223a1.263,1.263,0,0,1-.956.4c-1.883-.007-3.766,0-5.648,0a1.046,1.046,0,0,1-1.149-1.136c0-1.894,0-3.789-.005-5.683a1.351,1.351,0,0,1,.466-1q4.66-4.651,9.313-9.309c1.062-1.062,2.12-2.128,3.19-3.181a.477.477,0,0,0,.139-.541,11.177,11.177,0,0,1,2.8-11.2,10.841,10.841,0,0,1,6.511-3.309c.3-.042.59-.09.885-.134h1.525a.862.862,0,0,0,.163.047,11.244,11.244,0,0,1,7.011,3.161,10.893,10.893,0,0,1,3.085,5.233c.188.733.281,1.49.417,2.236ZM665.2,69.929c0-.558,0-1.1,0-1.639a1.068,1.068,0,0,1,1.22-1.2c.647,0,1.294-.013,1.941.005a.816.816,0,0,0,.667-.266c.743-.76,1.521-1.487,2.257-2.253a1.315,1.315,0,0,1,1.562-.351,8.79,8.79,0,0,0,4.052.517,9.067,9.067,0,0,0,7.408-4.978,9.286,9.286,0,0,0-2.049-11.289,9.338,9.338,0,0,0-15.032,10.1,1.409,1.409,0,0,1-.383,1.647q-6.292,6.258-12.56,12.539a.764.764,0,0,0-.247.6c.012,1.225.005,2.449.005,3.674v.383c1.249,0,2.451-.029,3.65.013a1.47,1.47,0,0,0,1.319-.549.8.8,0,0,0,.217-.676c-.082-.583-.159-1.168-.2-1.755a1,1,0,0,1,.958-1.132q1.033-.114,2.069-.2c.206-.016.3-.065.317-.3.046-.668.126-1.333.189-2a1.034,1.034,0,0,1,1.225-1.046C664.247,69.816,664.7,69.875,665.2,69.929Z",
    transform: "translate(-647.46 -44)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 647.46, 44)",
    filter: "url(#Trac\\xE9_85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85-2",
    "data-name": "Trac\\xE9 85",
    d: "M930.8,112.353a3.11,3.11,0,1,1,3.111-3.1A3.119,3.119,0,0,1,930.8,112.353Zm1.034-3.12a1.032,1.032,0,1,0-1.023,1.041A1.026,1.026,0,0,0,931.837,109.232Z",
    transform: "translate(-899.3 -100.75)",
    fill: "#50b2dc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.db2b9dc09623cab6e2528ac69b2e2058.svg";
export { ForwardRef as ReactComponent };